/*global jQuery */
(function($) {

  'use strict';
  
  $(document).ready(function(){

  	$('.articolo-blog img').each(function() {
      $(this).addClass('img-responsive');
    });
    
  	var bLazy = new Blazy({ 
	        breakpoints: [{
	  			width: 420, 
	  			src: 'data-src-small'
			}, {
		        width: 768, 
		        src: 'data-src-medium'
			}, {
		       	width: 1199, 
		       	src: 'data-src-large'
			}]
		});

	});

}(jQuery));